import { Component, OnInit, ViewRef, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { formatDate } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { IomService } from 'src/app/services/iom.service';
import { Location } from '@angular/common';
import { DeepDiveDetails } from 'src/app/models/DeepDiveDetails';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionService } from 'src/app/services/session.service'
import { MessageService } from 'src/app/services/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BtInsightService } from 'src/app/services/charts.service';
import { AppConfigService } from 'src/app/services/app-config.service';
import { timeout } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';

declare var bootbox: any;
declare var $: any;
@Component({
  selector: 'app-data-quality-assessment',
  templateUrl: './data-quality-assessment.component.html',
  styleUrls: ['./data-quality-assessment.component.css']
})
export class DataQualityAssessmentComponent implements OnInit {
  @Input() magicNumber: any;
  @Input() isProceed: any;
  abort = false;
  isLoadDQT = false;
  isLoadDataCompleteness = false;
  isLoadDataRedundancy = false;
  isLoadDataValidity = false;
  isLoadDataClarity = false;
  graphDataRedundancy: any;
  GraphData: any;
  VersionId: string;
  envVar: any;
  userName: string;
  inputDQT: number = 0;
  dataCompletenessMandate = [];
  dataCompletenessNonMandate = [];
  columnRelevanceMandate = [];
  columnRelevanceNonMandate = [];
  columnRelevance = [];
  dqtScore = [];
  relevanceFields = [];
  dataRedundancySimilarColumns = [];
  nonzerovalue = false;
  inputDataQuality: any;
  inputDataCompleteness: any;
  inputDataRedundancy: any;
  inputDataValidity: any;
  inputDataClarity: any;
  isMandate: boolean = true;
  isColumnRelevance: boolean;
  isSimilarColumns: boolean;
  isDuplicateColumnCount: boolean;
  isDuplicateColumns: boolean;
  duplicateTicketsCount: number;
  similarFieldsCount: number;
  duplicateFieldsCount: number;
  duplicateTicketsPercentage: number;
  similarFieldsPercentage: number;
  duplicateFieldsPercentage: number;
  isLoadDeepdive: boolean;
  isLoadReview: boolean;
  isLoadTrend: boolean;
  isLoadText: boolean;
  ddFilter: boolean;
  graphDataCompleteness = [];
  container = "#containerDQT";
  dualaxischart = [];
  graphMandate = [];
  graphNonMandate = [];
  dualaxischartMandate = [];
  dualaxischartNonMandate = [];
  dataClarityShortDesc = [];
  dataClarityResolnDesc = [];
  dataClarityQualifiedDesc = [];
  dataClarity = [];
  graphDataClarity = [];
  containerwordCloudDQT: string;
  wordCloudDataLength: any;
  wordCloudDataDQT: any;
  columnRelevanceLabel: string;
  wordCloudLabel: string;
  graphDataValidity = [];
  tabelDataValidity = [];
  tabelDataValidityLabel: string;
  chartTypeDataValidity: number;
  dataClarityDescType: number;
  descriptionName: string;
  header: string;
  isDisabled: boolean;
  IsDisplayMessageClarity: number;
  IsDisplayMessageValidity: number;
  isResolutionDescEnabledTask: boolean = true;

  constructor(private appConfigService: AppConfigService, private messageService: MessageService, private activatedRoute: ActivatedRoute, private router: Router, private sessionService: SessionService, private spinner: NgxSpinnerService, public iomservice: IomService) {
    this.envVar = this.appConfigService.getEnvironment();
    this.userName = this.sessionService.getUserName();
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
  }

  ngOnInit() { }

  ngOnChanges() {
    this.isLoadDQT = true;
    this.isDisabled = false;
    this.isLoadDataCompleteness = false;
    this.isLoadDataRedundancy = false;
    this.isLoadDataValidity = false;
    this.isLoadDataClarity = false;
    this.isColumnRelevance = false;
    this.inputDataQuality = [0, 0];
    this.inputDataCompleteness = [0, 1];
    this.inputDataRedundancy = [0, 2];
    this.inputDataValidity = [0, 3];
    this.inputDataClarity = [0, 4];
    this.GetDQTScore();
  }

  loadDataCompleteness() {
    this.spinner.show();
    this.isLoadDQT = false;
    this.isMandate = true;
    this.isLoadDataCompleteness = true;
    this.isLoadDataRedundancy = false;
    this.isLoadDataValidity = false;
    this.isLoadDataClarity = false;
    this.magicNumber++;
    this.GetDataCompleteness();
    this.isColumnRelevance = false;
    if (this.isProceed == true) {
      this.isLoadDeepdive = false;
      this.isLoadReview = false;
      this.isLoadTrend = false;
      this.isLoadText = false;
      this.ddFilter = false;
    }
  }

  loadDataRedundancy() {
    this.isLoadDQT = false;
    this.isLoadDataCompleteness = false;
    this.isLoadDataRedundancy = true;
    this.isLoadDataValidity = false;
    this.isLoadDataClarity = false;
    this.magicNumber++;
    this.GetDataRedundancy();
    this.isDuplicateColumnCount = false;
    this.isSimilarColumns = false;
    this.isDuplicateColumns = false;
  }

  loadDataValidity() {
    this.isLoadDQT = false;
    this.isLoadDataCompleteness = false;
    this.isLoadDataRedundancy = false;
    this.isLoadDataValidity = true;
    this.isLoadDataClarity = false;
    this.magicNumber++;
    this.GetDataValidity();
  }

  loadDataClarity() {
    this.isLoadDQT = false;
    this.isLoadDataCompleteness = false;
    this.isLoadDataRedundancy = false;
    this.isLoadDataValidity = false;
    this.isLoadDataClarity = true;
    this.magicNumber++;
    this.GetDataClarity();
    var TicketType = this.sessionService.getSessionStorageItem('TicketType');
    var userType = this.sessionService.getSessionStorageItem('userType');
    if(TicketType!=null && TicketType=="Task" && userType=="3")
    {
      this.isResolutionDescEnabledTask = false;
    }
    else{
      this.isResolutionDescEnabledTask = true;
    }
  }

  AbortDQT() {
    //this.spinner.show();
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.AbortDQT(this.VersionId).subscribe((data: any) => {
      if (data != null) {
        if (data.Result.indexOf('Success') > -1) {
          bootbox.alert(data.Result, function () {           
            this.abort = true;
            //$('#btnProceedAbort').hide();
            $('#complete').hide();
            $('#redundancy').hide();
            $('#validity').hide();
            $('#clarity').hide();
          });
          this.isDisabled = true;
          this.messageService.updateDDredirection('dqt')
        }
        else {
          bootbox.alert(data.Result);
        }
      }
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert('Error Occured !');
      });
  }

  ProceedDQT() {
    let that = this;
    //this.spinner.show();
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.ProceedDQT(this.VersionId).subscribe((data: any) => {
      if (data != null) {
        if (data.Result.indexOf('success') > -1) {
          bootbox.alert(data.Result, function () {
                               
          });
          this.isDisabled = true;   
          this.messageService.updateDDredirection('dqt')       
        }
        else {
          bootbox.alert(data.Result);
        }
        this.spinner.hide();
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert('Error Occured !');
      });
  }

  GetDataCompleteness() {
    this.spinner.show();
    this.nonzerovalue = false;
    this.dataCompletenessMandate = [];
    this.dataCompletenessNonMandate = [];
    this.columnRelevanceMandate = [];
    this.columnRelevanceNonMandate = [];
    this.graphDataCompleteness = [];
    this.dualaxischart = [];
    this.graphMandate = [];
    this.graphNonMandate = [];
    this.dualaxischartMandate = [];
    this.dualaxischartNonMandate = [];
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.GetDataCompletenessByVersionId(this.VersionId).subscribe((data: any) => {
      this.spinner.hide();
      if (data.length > 0 && data != null) {
        data.forEach((x, i) => {
          if (x.IsMandate == true) {
            this.dataCompletenessMandate.push({
              Column: x.Column,
              ChartId: x.ChartId,
              Percentage: x.Percentage,
              Ticket_Count: x.Ticket_Count,
              ChartIdentifier_Name: x.ChartIdentifier_Name,
              IsMandate: x.IsMandate
            })
            if (x.ChartId == 2 || x.ChartId == 3 || x.ChartId == 4) {
              this.columnRelevanceMandate.push({
                Column: x.Column,
                Ticket_Count: x.Ticket_Count,
                ChartId: x.ChartId,
              })
            }
            if (x.ChartId == 5) {
              this.graphMandate.push({
                sankeyXData: x.Column,
                sankeyData: x.Ticket_Count,
                XAxis: "Unique Values"
              })
            }
            if (x.ChartId == 1) {
              this.dualaxischartMandate.push({
                Column: x.Column,
                Percentage: x.Percentage,
                Ticket_Count: x.Ticket_Count,
                XAxis: "No of Tickets",
                yAxis: "Field Name",
                zAxis: "Percentage"
              })
            }
          }
          else {
            this.dataCompletenessNonMandate.push({
              Column: x.Column,
              ChartId: x.ChartId,
              Percentage: x.Percentage,
              Ticket_Count: x.Ticket_Count,
              ChartIdentifier_Name: x.ChartIdentifier_Name,
              IsMandate: x.IsMandate
            })
            if (x.ChartId == 2 || x.ChartId == 3 || x.ChartId == 4) {
              this.columnRelevanceNonMandate.push({
                Column: x.Column,
                Ticket_Count: x.Ticket_Count,
                ChartId: x.ChartId
              })
            }
            if (x.ChartId == 5) {
              this.graphNonMandate.push({
                sankeyXData: x.Column,
                sankeyData: x.Ticket_Count,
                XAxis: "Unique Values"
              })
            }
            if (x.ChartId == 1) {
              this.dualaxischartNonMandate.push({
                Column: x.Column,
                Percentage: x.Percentage,
                Ticket_Count: x.Ticket_Count,
                XAxis: "No of Tickets",
                yAxis: "Field Name",
                zAxis: "Percentage"
              })
            }
          }
        });
        this.columnRelevance = this.columnRelevanceMandate;
        for (let i = 0; i < this.columnRelevance.length; i++) {
          if(this.columnRelevance[i].Ticket_Count > 0){
            this.nonzerovalue = true;
          }
        }
        this.graphDataCompleteness = this.graphMandate;
        this.dualaxischart = this.dualaxischartMandate;
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }

  GetDQTScore() {
    this.spinner.show();
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.GetDQTScoreByVersionId(this.VersionId).subscribe((data: any) => {
      if (data.length > 0 && data != null) {
        for (var i = 0; i < data.length; i++) {
          this.dqtScore.push({
            Field_Name: data[i].Field_Name,
            Percentage: data[i].Percentage
          })
          if (data[i].Field_Name == "Data Quality Percentage") {
            this.inputDataQuality = [data[i].Percentage, 0];
            this.inputDQT = data[i].Percentage;
          }
          else if (data[i].Field_Name == "Data Completeness") {
            this.inputDataCompleteness = [data[i].Percentage, 1];
          }
          else if (data[i].Field_Name == "Data Redundancy") {
            this.inputDataRedundancy = [data[i].Percentage, 2];
          }
          else if (data[i].Field_Name == "Data Validity") {
            this.inputDataValidity = [data[i].Percentage, 3];
            this.IsDisplayMessageValidity = data[i].IsDisplayMessage;
            // this.IsDisplayMessageValidity = 1;
          }
          else if (data[i].Field_Name == "Data Clarity") {
            this.inputDataClarity = [data[i].Percentage, 4];
            this.IsDisplayMessageClarity = data[i].IsDisplayMessage;
            // this.IsDisplayMessageClarity = 1;
          }
          else {
            this.inputDataQuality = [0, 0];
            this.inputDataCompleteness = [0, 1];
            this.inputDataRedundancy = [0, 2];
            this.inputDataValidity = [0, 3];
            this.inputDataClarity = [0, 4];
          }
        }
      }
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }

  GetFieldsData(value: any, ChartId: number, RowRanking: number) {
    this.spinner.show();
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    if (value != 0 && value != undefined && value != null) {
      if (RowRanking == 1) {
        this.isColumnRelevance = true;
        this.dataCompletenessMandate = [];
        this.iomservice.GetColumnRelevanceFields(this.VersionId, this.isMandate, null, RowRanking, ChartId).subscribe((data: any) => {
          if (data.result == "Success") {
            this.spinner.hide();
            if (data.result_fields.length > 0 && data != null) {
              this.columnRelevanceLabel = ChartId == 2 ? "Fields have no data and not relevant" : ChartId == 3 ? "Fields with less data" : ChartId == 4 ? "Field with more unique data" : "";
              data.result_fields.forEach((x, i) => {
                this.dataCompletenessMandate.push({
                  Sno: i + 1,
                  Column: x.Column,
                  percentage_null_count: x.percentage_null_count
                })
              });
            }
          }
          else {
            this.spinner.hide();
            bootbox.alert("Request Failed");
          }
        },
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            bootbox.alert("Timeout. Please Refresh and Try again");
          });
      }
      else if (RowRanking == 2) {
        this.dataRedundancySimilarColumns = [];
        this.iomservice.GetDuplicateAndSimilarFields(this.VersionId, null, null, RowRanking, ChartId).subscribe((data: any) => {
          if (data.result == "Success") {
            this.spinner.hide();
            if (data.result_fields.length > 0 && data != null) {
              data.result_fields.forEach((x, i) => {
                if (ChartId == 1 && data.ChartId == 1) {
                  this.isDuplicateColumnCount = true;
                  this.isSimilarColumns = false;
                  this.isDuplicateColumns = false;
                  this.dataRedundancySimilarColumns.push({
                    Sno: i + 1,
                    IncidentNumber: x.IncidentNumber,
                    TicketCount: x.TicketCount
                  })
                }
                else if (ChartId == 2 && data.ChartId == 2) {
                  this.isDuplicateColumnCount = false;
                  this.isSimilarColumns = true;
                  this.isDuplicateColumns = false;
                  this.dataRedundancySimilarColumns.push({
                    Sno: i + 1,
                    ColumnName: x.ColumnName
                  })
                }
                else if (ChartId == 3 && data.ChartId == 3) {
                  this.isDuplicateColumnCount = false;
                  this.isSimilarColumns = false;
                  this.isDuplicateColumns = true;
                  this.dataRedundancySimilarColumns.push({
                    Sno: i + 1,
                    ColumnName: x.ColumnName
                  })
                }
              });
            }
          }
          else {
            this.spinner.hide();
            bootbox.alert("Request Failed");
          }
        },
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            bootbox.alert("Timeout. Please Refresh and Try again");
          });
      }
    }
    else {
      this.spinner.hide();
    }
  }

  GetDataRedundancy() {
    this.spinner.show();
    this.graphDataRedundancy = [];
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.GetDataRedundancyByVersionId(this.VersionId).subscribe((data: any) => {
      this.spinner.hide();
      if (data != null) {
        if (data.Result == "success") {
          data.result_fields.forEach((x, i) => {
            if (x.ChartId == 1) {
              this.duplicateTicketsCount = x.Ticket_Count;
              this.duplicateTicketsPercentage = x.Percentage;
            }
            else if (x.ChartId == 2) {
              this.similarFieldsCount = x.Ticket_Count;
              this.similarFieldsPercentage = x.Percentage;
            }
            else if (x.ChartId == 3) {
              this.duplicateFieldsCount = x.Ticket_Count;
              this.duplicateFieldsPercentage = x.Percentage;
            }
          });
          this.graphDataRedundancy.push({
            SimilarColumn: this.similarFieldsPercentage,
            DuplicateColumn: this.duplicateFieldsPercentage
          })
        }
        else if (data.Result == "No Records Found") {
        }
      }
      else {
        bootbox.alert("Request Failed");
        this.spinner.hide();
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }

  loadMandate(toggle: boolean) {
    this.spinner.show();
    this.columnRelevance = [];
    this.nonzerovalue = false;
    this.graphDataCompleteness = [];
    this.dualaxischart = [];
    this.container = "#containerDQT";
    if (toggle == false) {
      this.columnRelevance = this.columnRelevanceNonMandate;
      for (let i = 0; i < this.columnRelevance.length; i++) {
        if(this.columnRelevance[i].Ticket_Count > 0){
          this.nonzerovalue = true;
        }
      }
      this.graphDataCompleteness = this.graphNonMandate;
      this.dualaxischart = this.dualaxischartNonMandate;
      this.isColumnRelevance = false;
      this.isMandate = false;
      this.spinner.hide();
    }
    else {
      this.columnRelevance = this.columnRelevanceMandate;
      for (let i = 0; i < this.columnRelevance.length; i++) {
        if(this.columnRelevance[i].Ticket_Count > 0){
          this.nonzerovalue = true;
        }
      }
      this.graphDataCompleteness = this.graphMandate;
      this.dualaxischart = this.dualaxischartMandate;
      this.isColumnRelevance = false;
      this.isMandate = true;
      this.spinner.hide();
    }
  }

  GetDataClarity() {
    this.spinner.show();
    this.dataClarity = [];
    this.dataClarityResolnDesc = [];
    this.dataClarityQualifiedDesc = [];
    this.dataClarityShortDesc = [];
    this.graphDataClarity = [];
    var xAxisCategories = [];
    var newKeys = [];
    this.wordCloudLabel = "";
    this.wordCloudDataDQT = null;
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.GetDataClarityByVersionId(this.VersionId).subscribe((data: any) => {
      this.spinner.hide();
      if (data.length > 0 && data != null) {
        data.forEach((x, i) => {
          this.dataClarityDescType = x.Description;
          this.descriptionName = this.dataClarityDescType == 2 ? x.DescriptionName : "Qualified Description";
          if (x.DescriptionType == 1) {
            this.dataClarityShortDesc.push({
              FieldName: x.FieldName,
              ChartId: x.FieldName.replace(/ /g, '') == "1to3Words" ? 1 : x.FieldName.replace(/ /g, '') == "4to10words" ? 2 : x.FieldName.replace(/ /g, '') == "11to30words" ? 3 : 4,
              Percentage: x.Percentage,
              Ticket_Count: x.Ticket_Count,
              DescriptionType: x.DescriptionType
            })
          }
          else if (x.DescriptionType == 2) {
            this.dataClarityQualifiedDesc.push({
              FieldName: x.FieldName,
              ChartId: x.FieldName.replace(/ /g, '') == "1to3Words" ? 1 : x.FieldName.replace(/ /g, '') == "4to10words" ? 2 : x.FieldName.replace(/ /g, '') == "11to30words" ? 3 : 4,
              Percentage: x.Percentage,
              Ticket_Count: x.Ticket_Count,
              DescriptionType: x.DescriptionType
            })
          }
          else {
            this.dataClarityResolnDesc.push({
              FieldName: x.FieldName,
              ChartId: x.FieldName.replace(/ /g, '') == "1to3Words" ? 1 : x.FieldName.replace(/ /g, '') == "4to10words" ? 2 : x.FieldName.replace(/ /g, '') == "11to30words" ? 3 : 4,
              Percentage: x.Percentage,
              Ticket_Count: x.Ticket_Count,
              DescriptionType: x.DescriptionType
            })
          }
        });
        if (this.dataClarityDescType == 1) {
          this.dataClarity = this.dataClarityShortDesc;
          this.header = "Short Description Words"
        } 
        else  if (this.dataClarityDescType == 2) {
          this.dataClarity = this.dataClarityQualifiedDesc;
          this.header =  this.dataClarityDescType == 2 ? this.descriptionName + " Words" : "Qualified Description Words" ;
        }        
        else {
          this.dataClarity = this.dataClarityResolnDesc;
          this.header = "Resolution Description Words"
        }
       
        this.dataClarity.forEach((x, i) => {
          this.graphDataClarity.push({
            sankeyXData: x.FieldName,
            sankeyData: x.Ticket_Count,
            XAxis: "Total Resources",
            VersionId: this.VersionId,
            ChartId: x.ChartId,
            DescriptionType: x.DescriptionType
          })

          for (let i = 0; i < this.dataClarity.length; i++) {
            xAxisCategories[i] = this.dataClarity[i].FieldName;
          }
          for (let i = 0; i < this.dataClarity.length; i++) {
            newKeys[i] = this.dataClarity[i].FieldName;
          }
        });

        var inputData = { chartData: this.graphDataClarity, chartContainerName: '#doughnutChart', newKeys: newKeys, currentGroup: 1, xAxisCategories: xAxisCategories };
        this.GraphData = inputData;
      }
      else {
        this.spinner.hide();
        bootbox.alert("Request Failed");
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }

  LoadWordCloud(d, i) {
    this.spinner.show();
    this.wordCloudDataDQT = null;
    this.iomservice.GetDataClarityDescriptionDetails(d.data.VersionId, null, d.data.DescriptionType, 4, d.data.ChartId).subscribe((data: any) => {
      this.spinner.hide();
      if (data != undefined && data != null && data.result_fields != null && data.result_fields != undefined) {
        this.containerwordCloudDQT = "containerwordCloudDQT";
        this.wordCloudLabel = d.data.sankeyXData;
        this.wordCloudDataDQT = data.result_fields.Word_Cloud;
        this.wordCloudDataLength = Object.keys(data.result_fields.Word_Cloud).length;
      }
      else {
        bootbox.alert("Request Failed");
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }

  toggleDataClarity(toggle: string) {
    this.spinner.show();
    this.dataClarity = [];
    var xAxisCategories = [];
    var newKeys = [];
    this.graphDataClarity = [];
    if (toggle == 'Short') {
      this.dataClarity = this.dataClarityShortDesc;
      this.header = "Short Description Words"
    }
    else if (toggle == 'Resolution') {
      this.dataClarity = this.dataClarityResolnDesc;
      this.header = "Resolution Description Words"
    }
    else {
      this.dataClarity = this.dataClarityQualifiedDesc;
      this.header = this.dataClarityDescType == 2 ? this.descriptionName + " Words" : "Qualified Description Words" ;
    }
    this.dataClarity.forEach((x, i) => {
      this.graphDataClarity.push({
        sankeyXData: x.FieldName,
        sankeyData: x.Ticket_Count,
        XAxis: "Total Resources",
        VersionId: this.VersionId,
        ChartId: x.ChartId,
        DescriptionType: x.DescriptionType
      })

      for (let i = 0; i < this.dataClarity.length; i++) {
        xAxisCategories[i] = this.dataClarity[i].FieldName;
      }

      for (let i = 0; i < this.dataClarity.length; i++) {
        newKeys[i] = this.dataClarity[i].FieldName;
      }
    });

    var inputData = { chartData: this.graphDataClarity, chartContainerName: '#doughnutChart', newKeys: newKeys, currentGroup: 1, xAxisCategories: xAxisCategories };
    this.GraphData = inputData;
    this.wordCloudDataDQT = null;
    this.containerwordCloudDQT = "containerwordCloudDQT";
    this.wordCloudLabel = "";
    this.wordCloudDataDQT = null;
    this.spinner.hide();
  }

  GetDataValidity() {
    this.spinner.show();
    this.graphDataValidity = [];
    this.tabelDataValidity = [];
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.GetDataValidityByVersionId(this.VersionId).subscribe((data: any) => {
      this.spinner.hide();
      if (data.length > 0 && data != null) {
        this.graphDataValidity = data;
      }
      else {
        bootbox.alert("Request Failed");
        this.spinner.hide();
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }

  GetDataValidityDetails(d, i) {
    this.spinner.show();
    this.VersionId = this.sessionService.getSessionStorageItem('VersionIdMongo');
    this.iomservice.GetDataValidityDescriptionDetails(this.VersionId, null, null, 3, d.ChartId).subscribe((data: any) => {
      if (data != undefined && data != null && data.result == "Success") {
        this.tabelDataValidity = [];
        this.chartTypeDataValidity = data.ChartId;
        this.tabelDataValidityLabel = d.FieldName;
        data.result_fields.forEach((x, i) => {
          this.tabelDataValidity.push({
            IncidentNumber: x.IncidentNumber,
            ReportedDateTime: x.ReportedDateTime == null ? "" : formatDate(x.ReportedDateTime, 'dd-MM-yyyy', 'en-US'),
            TicketClosedDate: x.TicketClosedDate == null ? "" : formatDate(x.TicketClosedDate, 'dd-MM-yyyy', 'en-US'),
            SLAResolution: data.ChartId == 1 ? x.SLAResolution : null,
            ResolutionDescription: data.ChartId == 2 ? x.ResolutionDescription : null,
            Effort: data.ChartId == 3 ? x.Effort == 0 ? '' : x.Effort : null,
            Status: data.ChartId == 4 ? x.Status : null
          })
        });
      }
      else {
        bootbox.alert("Request Failed");
      }
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        bootbox.alert("Timeout. Please Refresh and Try again");
      });
  }
}
